import request from "../web-sh/src/utils/request";
import global from "../config/global";

async function get_claim(params = {}) {
  return request({
    url: global.endpoint.REWARD_CLAIM,
    method: "get",
    params
  });
}

async function get_missions(params = {}) {
  return request({
    url: global.endpoint.REWARD_MISSIONS,
    method: "get",
    params
  });
}

async function get_promo_codes(params = {}) {
  return request({
    url: global.endpoint.REWARD_CLAIM_PROMO_CODES,
    method: "get",
    params
  });
}

async function get_code() {
  return request({
    url: global.endpoint.REWARD_CLAIM_PROMO_CODES,
    method: "post"
  });
}

async function mission_completed(id, data) {
  return request({
    url: global.endpoint.REWARD_MISSION_COMPLETED.replace(':id', id),
    method: "post",
    data
  });
}

export default {
  get_claim,
  get_missions,
  get_promo_codes,
  get_code,
  mission_completed
};
